var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiveUsoGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000110435444085615994570000010266050689263067029_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 406.6 50",
    style: {
      enableBackground: "new 0 0 406.6 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1741B5;}\n\t.st1{fill:none;stroke:#1741B5;stroke-width:0.86;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 3.6,
    className: "st0",
    width: 10.2,
    height: 41.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 3.6,
    className: "st0",
    width: 10.2,
    height: 41.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 3.6,
    className: "st0",
    width: 10.2,
    height: 41.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.2,
    y: 3.6,
    className: "st0",
    width: 10.2,
    height: 41.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.3,3.6 40.8,3.6 26.1,23.6 14.9,23.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "90.7,3.6 104.4,3.6 73.7,45.2 73.7,27.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.5,25.2 14.9,25.2 29.7,45.2 40.8,45.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.5,1.1 137.2,8.6 149,23.6 160.2,23.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148.7,25.2 160.2,25.2 143.5,46.7 136.7,39.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 3.6,
    className: "st0",
    width: 16,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 19.6,
    className: "st0",
    width: 9.7,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 36.2,
    className: "st0",
    width: 16,
    height: 9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.6,19.1c0.9,0.8,2,1.2,3.4,1.2s2.6-0.4,3.4-1.2c0.8-0.8,1.2-1.9,1.2-3.4V5h3.7v10.7c0,1.6-0.3,3-1,4.1 c-0.7,1.2-1.6,2.1-2.9,2.7c-1.2,0.6-2.7,0.9-4.4,0.9c-1.7,0-3.2-0.3-4.5-0.9c-1.3-0.6-2.2-1.5-2.9-2.7c-0.7-1.2-1-2.5-1-4.1V5h3.7 v10.7C178.3,17.2,178.8,18.3,179.6,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.7,8.4c-1-0.3-1.9-0.5-2.7-0.5c-0.9,0-1.6,0.2-2.1,0.5c-0.5,0.3-0.8,0.7-0.8,1.3c0,0.5,0.2,0.9,0.5,1.3 c0.4,0.3,0.8,0.6,1.3,0.8c0.5,0.2,1.3,0.5,2.2,0.7c1.3,0.4,2.4,0.7,3.2,1.1c0.8,0.4,1.5,0.9,2.1,1.6c0.6,0.7,0.9,1.6,0.9,2.8 c0,1.1-0.3,2.1-0.9,2.9c-0.6,0.8-1.5,1.5-2.6,1.9c-1.1,0.4-2.4,0.7-3.8,0.7c-1.5,0-3-0.3-4.4-0.8c-1.4-0.5-2.7-1.2-3.7-2.1l1.5-3 c1,0.9,2,1.5,3.3,2c1.2,0.5,2.3,0.7,3.4,0.7c1,0,1.8-0.2,2.4-0.6s0.9-0.9,0.9-1.5c0-0.5-0.2-0.9-0.5-1.3c-0.4-0.3-0.8-0.6-1.4-0.8 c-0.5-0.2-1.3-0.4-2.2-0.7c-1.3-0.4-2.3-0.7-3.2-1.1c-0.8-0.3-1.5-0.9-2.1-1.6s-0.9-1.6-0.9-2.8c0-1.1,0.3-2,0.9-2.8 s1.4-1.4,2.5-1.8c1.1-0.4,2.3-0.7,3.8-0.7c1.2,0,2.5,0.2,3.7,0.5c1.2,0.3,2.3,0.8,3.2,1.4l-1.5,3C206.7,9.1,205.7,8.7,204.7,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.7,6c1.6,0.8,2.8,1.9,3.7,3.4s1.3,3,1.3,4.7s-0.4,3.3-1.3,4.7s-2.1,2.6-3.7,3.4c-1.6,0.8-3.3,1.2-5.2,1.2 s-3.6-0.4-5.2-1.2c-1.6-0.8-2.8-2-3.7-3.4s-1.3-3-1.3-4.7s0.4-3.3,1.3-4.7s2.1-2.5,3.7-3.4c1.6-0.8,3.3-1.2,5.2-1.2 S225.1,5.2,226.7,6z M218.3,8.7c-1,0.5-1.8,1.3-2.4,2.2c-0.6,0.9-0.9,2-0.9,3.1c0,1.1,0.3,2.2,0.9,3.1c0.6,1,1.4,1.7,2.4,2.3 c1,0.6,2.1,0.8,3.2,0.8c1.1,0,2.2-0.3,3.2-0.8c1-0.6,1.8-1.3,2.3-2.3c0.6-1,0.9-2,0.9-3.1c0-1.1-0.3-2.2-0.9-3.1 c-0.6-0.9-1.4-1.7-2.3-2.2c-1-0.5-2-0.8-3.2-0.8C220.4,7.9,219.3,8.2,218.3,8.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188,39.5h3.2v6.9c-1,0.7-2.2,1.3-3.6,1.7c-1.4,0.4-2.7,0.7-4,0.7c-1.9,0-3.6-0.4-5.1-1.2 c-1.5-0.8-2.8-2-3.6-3.4s-1.3-3-1.3-4.7s0.5-3.3,1.4-4.7c0.9-1.4,2.2-2.5,3.7-3.4c1.6-0.8,3.3-1.2,5.2-1.2c1.4,0,2.7,0.2,4,0.7 s2.5,1.1,3.4,1.9l-2.1,2.6c-0.7-0.7-1.6-1.2-2.5-1.5c-1-0.4-1.9-0.5-2.9-0.5c-1.2,0-2.3,0.3-3.3,0.8c-1,0.5-1.8,1.3-2.4,2.3 c-0.6,1-0.9,2-0.9,3.1c0,1.1,0.3,2.2,0.9,3.1c0.6,1,1.4,1.7,2.4,2.3c1,0.6,2.1,0.8,3.3,0.8c0.7,0,1.3-0.1,2.1-0.3 c0.7-0.2,1.4-0.5,2.1-0.8V39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.4,30.4h14v3h-10.4v4.5h9.3v3h-9.3v4.6h10.7v3h-14.3V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.8,30.4h3.6v18.2h-3.5l-9.8-12.5v12.5h-3.6V30.4h3.5l9.9,12.6V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.1,30.4h14v3h-10.4v4.5h9.3v3h-9.3v4.6h10.7v3h-14.3V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.1,48.6l-3.3-5.4c-0.1,0-0.4,0-0.7,0h-4.3v5.4h-3.7V30.4h8c2.5,0,4.4,0.5,5.7,1.6c1.3,1.1,2,2.6,2,4.6 c0,1.4-0.3,2.6-1,3.6c-0.6,1-1.6,1.8-2.8,2.3l4.2,6H265.1z M256.8,40.2h4.3c1.4,0,2.4-0.3,3.2-0.9c0.7-0.6,1.1-1.4,1.1-2.5 c0-1.1-0.4-1.9-1.1-2.5c-0.7-0.6-1.8-0.8-3.2-0.8h-4.3V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,48.6l-1.7-3.9H276l-1.7,3.9h-3.8l8.4-18.2h3.8l8.3,18.2H287z M277.3,41.8h6.7l-3.3-7.6L277.3,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.3,30.4h3.7v15.1h8.3v3.1h-11.9V30.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiveUsoGeneral);
export default __webpack_public_path__ + "static/media/kive-uso-general.96ef1decf101518fba818d16af1b32ef.svg";
export { ForwardRef as ReactComponent };